import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import App from '../common/app'
import StatementsComponent from './components/index'
import { getMyStatements } from './actions'
import { getDealers } from '../dealers/actions'

function render (mountNode) {
  return function () {
    renderWithRoot(
      <App active="statements" {...getState()} {...appActions}>
        <StatementsComponent {...getState()} {...appActions} />
      </App>,
      mountNode
    )
  }
}

let unsubscribe = function () {}

export default function (app, mountNode) {
  app('/statements', context => {
    unsubscribe = subscribe(render(mountNode))
    if (getState().session.id) {
      getMyStatements()
      // Load dealers for admin users
      const session = getState().session
      if (session.user && session.user.roles && session.user.roles.some(role => ['DataProvider', 'Administrator', 'Sales'].includes(role))) {
        getDealers()
      }
    }

    render(mountNode)()
  })

  app.exit('/statements', (context, next) => {
    unsubscribe()
    next()
  })
}
